const ALL_STRING = 'All'
const SEASON_STRING = 'Season'
const REGULAR_SEASON_STRING = 'Regular Season'
const PLAYOFFS_STRING = 'Playoffs'
const PLAY_IN_STRING = 'PlayIn'
const OPPONENT_STRING = 'Opponent'
const ASSISTED_STRING = 'Assisted'
const OFFENSIVE_ABBREVIATION_PREFIX = 'Off'
const DEFENSIVE_ABBREVIATION_PREFIX = 'Def'
const BLOCKED_STRING = 'Blocked'
const FREE_THROW_STRING = 'FT'
const AT_RIM_STRING = 'AtRim'
const SHORT_MID_RANGE_STRING = 'ShortMidRange'
const LONG_MID_RANGE_STRING = 'LongMidRange'
const CORNER_3_STRING = 'Corner3'
const ARC_3_STRING = 'Arc3'
const SECOND_CHANCE_STRING = 'SecondChance'
const ASSISTS_STRING = 'Assists'
const MAKE_STRING = 'Make'
const MISS_STRING = 'Miss'
const BLOCK_STRING = 'Block'
const OFF_DEADBALL_STRING = 'OffDeadball'
const OFF_LIVE_BALL_TURNOVER_STRING = 'OffLiveBallTurnover'
const OFF_TIMEOUT_STRING = 'OffTimeout'
const OFF_MADE_FT_STRING = 'Off' + FREE_THROW_STRING + MAKE_STRING
const OFF_MISSED_FT_STRING = 'Off' + FREE_THROW_STRING + MISS_STRING
const OFFENSIVE_POSSESSION_STRING = 'OffPoss'
const PER_100_POSSESSIONS_STRING = 'Per100Poss'
const POINTS_ABBREVIATION_STRING = 'Pts'
const TWOS_STRING = '2s'
const THREES_STRING = '3s'
const PENALTY_KEY = 'Penalty'
const PACE_STRING = 'Pace'
const ACCURACY_STRING = 'Accuracy'
const FREQUENCY_STRING = 'Frequency'
const FIRST_CHANCE_STRING = 'FirstChance'
const AVG_2PT_SHOT_DISTANCE = 'Avg2ptShotDistance'
const AVG_3PT_SHOT_DISTANCE = 'Avg3ptShotDistance'
const PCT_STRING = 'Pct'
const FG2A_STRING = 'FG2A'
const FG3A_STRING = 'FG3A'
const FTA_STRING = 'FTA'
const FG3_PCT_STRING = 'Fg3Pct'
const FG2_PCT_STRING = 'Fg2Pct'
const EFG_PCT_STRING = 'EfgPct'
const SHOT_QUALITY_AVG_STRING = 'ShotQualityAvg'
const REBOUND_STRING = 'Rebound'
const BLOCKS_STRING = 'Blocks'
const TURNOVERS_STRING = 'Turnovers'
const ASSIST_POINTS_STRING = 'AssistPoints'
const PENALTY_EFFICIENCY_EXCLUDING_TAKE_FOUL_FTS = 'PenaltyEfficiencyExcludingTakeFouls'
const POINTS_STRING = 'Points'
const DRAWN_STRING = 'Drawn'
const SHOOTING_FOULS_STRING = 'ShootingFouls'
const TWO_POINT_STRING = 'TwoPt'
const THREE_POINT_STRING = 'ThreePt'
const START_TIME_STRING = 'StartTime'
const END_TIME_STRING = 'EndTime'
const MISSED_FG_STRING = 'MissedFG'
const MISSED_2_STRING = 'Missed2'
const MISSED_MID_RANGE_STRING = 'MissedMidRange'
const MISSED_3_STRING = 'Missed3'
const NON_HEAVE_STRING = 'NonHeave'
const SECONDS_STRING = 'Seconds'
const PER_POSSESSION_STRING = 'PerPoss'
const RECOVERED_STRING = 'Recovered'
const FG_STRING = 'FG'
const OFF_STRING = 'Off'
const OFF_AT_RIM_MAKE_STRING = OFF_STRING + AT_RIM_STRING + MAKE_STRING
const OFF_AT_RIM_MISS_STRING = OFF_STRING + AT_RIM_STRING + MISS_STRING
const OFF_AT_RIM_BLOCK_STRING = OFF_STRING + AT_RIM_STRING + BLOCK_STRING
const OFF_SHORT_MID_RANGE_MAKE_STRING = OFF_STRING + SHORT_MID_RANGE_STRING + MAKE_STRING
const OFF_SHORT_MID_RANGE_MISS_STRING = OFF_STRING + SHORT_MID_RANGE_STRING + MISS_STRING
const OFF_LONG_MID_RANGE_MAKE_STRING = OFF_STRING + LONG_MID_RANGE_STRING + MAKE_STRING
const OFF_LONG_MID_RANGE_MISS_STRING = OFF_STRING + LONG_MID_RANGE_STRING + MISS_STRING
const OFF_ARC_3_MAKE_STRING = OFF_STRING + ARC_3_STRING + MAKE_STRING
const OFF_ARC_3_MISS_STRING = OFF_STRING + ARC_3_STRING + MISS_STRING
const OFF_CORNER_3_MAKE_STRING = OFF_STRING + CORNER_3_STRING + MAKE_STRING
const OFF_CORNER_3_MISS_STRING = OFF_STRING + CORNER_3_STRING + MISS_STRING
const OFF_MISSED_FG_STRING = 'OffMissedFG'
const OFF_MISSED_2_STRING = 'OffMissed2'
const OFF_MISSED_3_STRING = 'OffMissed3'
const OFF_MADE_FG_STRING = 'OffMadeFG'
const OFF_MADE_2_STRING = 'OffMade2'
const OFF_MADE_3_STRING = 'OffMade3'
const LIVE_BALL_TURNOVER_PERCENTAGE_STRING = 'LiveBallTurnoverPct'
const TS_PCT_STRING = 'TsPct'
const NON_HEAVE_FG3_PCT_STRING = NON_HEAVE_STRING + 'Fg3Pct'
const NON_PUTBACKS_STRING = 'NonPutbacks'
const ON_FLOOR_PLAYER_REQUEST_STRING = 'OnFloor'
const OFF_FLOOR_PLAYER_REQUEST_STRING = 'OffFloor'
const PLAYER_PLAYED_IN_GAME_REQUEST_STRING = 'PlayedInGame'
const PLAYER_DID_NOT_PLAY_IN_GAME_REQUEST_STRING = 'DidNotPlayInGame'
const STARTED_REQUEST_STRING = 'Started'
const CAME_OFF_BENCH_REQUEST_STRING = 'CameOffBench'
const LOW_LEVERAGE_STRING = 'Low'
const MEDIUM_LEVERAGE_STRING = 'Medium'
const HIGH_LEVERAGE_STRING = 'High'
const VERY_HIGH_LEVERAGE_STRING = 'VeryHigh'

const SEASONS = {
  'nba': ['2024-25', '2023-24', '2022-23', '2021-22', '2020-21', '2019-20', '2018-19', '2017-18', '2016-17', '2015-16', '2014-15', '2013-14', '2012-13', '2011-12', '2010-11', '2009-10', '2008-09', '2007-08', '2006-07', '2005-06', '2004-05', '2003-04', '2002-03', '2001-02', '2000-01'],
  'gleague': ['2020-21', '2019-20', '2018-19', '2017-18', '2016-17'],
  'wnba': ['2025', '2024', '2023', '2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013', '2012', '2011', '2010', '2009']
}

export const season = {
  methods: {
    getSeasonDropdownForLeague (league) {
      var seasons = []
      SEASONS[league].forEach((season) => {
        seasons.push({id: season, text: season})
      })
      return {
        label: SEASON_STRING,
        data: seasons
      }
    }
  }
}

export const seasonType = {
  data () {
    return {
      season_type_dropdown_options: {
        'label': 'Season Type',
        'data': [
          {'id': 'Regular+Season', 'text': REGULAR_SEASON_STRING},
          {'id': PLAYOFFS_STRING, 'text': PLAYOFFS_STRING},
          {'id': ALL_STRING, 'text': ALL_STRING},
          {'id': PLAY_IN_STRING, 'text': PLAY_IN_STRING}
        ]
      }
    }
  }
}

export const wowyOnOff = {
  data () {
    return {
      wowy_on_off_dropdown_options: {
        'label': '',
        'data': [
          {'id': ON_FLOOR_PLAYER_REQUEST_STRING, 'text': 'On'},
          {'id': OFF_FLOOR_PLAYER_REQUEST_STRING, 'text': 'Off'},
          {'id': PLAYER_PLAYED_IN_GAME_REQUEST_STRING, 'text': 'Played In Game'},
          {'id': PLAYER_DID_NOT_PLAY_IN_GAME_REQUEST_STRING, 'text': 'Did Not Play In Game'},
          {'id': STARTED_REQUEST_STRING, 'text': 'Started'},
          {'id': CAME_OFF_BENCH_REQUEST_STRING, 'text': 'Did Not Start'}
        ]
      }
    }
  }
}

export const numberType = {
  data () {
    return {
      number_type_dropdown_options: {
        'label': '',
        'data': [
          {'id': 'Exactly', 'text': 'Exactly'},
          {'id': 'GreaterThan', 'text': 'Greater Than'},
          {'id': 'LessThan', 'text': 'Less Than'}
        ]
      }
    }
  }
}

export const numberOfPlayers = {
  data () {
    return {
      number_of_players_dropdown_options: {
        'label': '',
        'data': [
          {'id': '0', 'text': '0 of'},
          {'id': '1', 'text': '1 of'},
          {'id': '2', 'text': '2 of'},
          {'id': '3', 'text': '3 of'},
          {'id': '4', 'text': '4 of'},
          {'id': '5', 'text': '5 of'}
        ]
      }
    }
  }
}

export const period = {
  data () {
    return {
      period_dropdown_options: {
        'label': 'Period',
        'data': [
          {'id': '1', 'text': '1'},
          {'id': '2', 'text': '2'},
          {'id': '3', 'text': '3'},
          {'id': '4', 'text': '4'},
          {'id': 'OT', 'text': 'OT'},
          {'id': '4_OT', 'text': '4 + OT'}
        ]
      }
    }
  }
}

export const possessionFinderOnOff = {
  data () {
    return {
      possession_finder_on_off_dropdown_options: {
        'label': '',
        'data': [
          {'id': ON_FLOOR_PLAYER_REQUEST_STRING, 'text': 'On'},
          {'id': OFF_FLOOR_PLAYER_REQUEST_STRING, 'text': 'Off'},
          {'id': PLAYER_PLAYED_IN_GAME_REQUEST_STRING, 'text': 'Played In Game'},
          {'id': PLAYER_DID_NOT_PLAY_IN_GAME_REQUEST_STRING, 'text': 'Did Not Play In Game'}
        ]
      }
    }
  }
}

export const possessionStartTimeType = {
  data () {
    return {
      possession_start_time_type_dropdown_options: {
        'label': '',
        'data': [
          {'id': START_TIME_STRING, 'text': 'Possession Start Time'},
          {'id': END_TIME_STRING, 'text': 'Possession Start Time'}
        ]
      }
    }
  }
}

export const orebShotType = {
  data () {
    return {
      oreb_shot_type_dropdown_options: {
        'label': 'Type of Missed Shot that was Offensive Rebounded',
        'data': [
          {'id': MISSED_FG_STRING, 'text': 'Any Missed FG'},
          {'id': MISSED_2_STRING, 'text': 'Any Missed 2'},
          {'id': MISSED_MID_RANGE_STRING, 'text': 'Any Mid Range Miss'},
          {'id': MISSED_3_STRING, 'text': 'Any Missed 3'},
          {'id': AT_RIM_STRING, 'text': 'Any At Rim Miss'},
          {'id': AT_RIM_STRING + BLOCKED_STRING, 'text': 'Any At Rim Blocked'},
          {'id': SHORT_MID_RANGE_STRING, 'text': 'Any Short Mid Range Miss'},
          {'id': LONG_MID_RANGE_STRING, 'text': 'Any Long Mid Range Miss'},
          {'id': ARC_3_STRING, 'text': 'Any Above the Break 3 Miss'},
          {'id': CORNER_3_STRING, 'text': 'Any Corner 3 Miss'},
          {'id': FREE_THROW_STRING, 'text': 'Any Free Throw Miss'}
        ]
      }
    }
  }
}

export const chart = {
  data () {
    return {
      chart_dropdown_options: [
        {'id': POINTS_ABBREVIATION_STRING + PER_100_POSSESSIONS_STRING, 'text': 'Points Per 100 Possessions'},
        {'id': SECONDS_STRING + PER_POSSESSION_STRING, 'text': 'Seconds Per Possession'},
        {'id': 'FG3APct', 'text': '3 Point Rate'},
        {'id': FG3_PCT_STRING, 'text': '3pt %'},
        {'id': AT_RIM_STRING + FREQUENCY_STRING, 'text': 'At Rim Shot Frequency'},
        {'id': AT_RIM_STRING + ACCURACY_STRING, 'text': 'At Rim FG%'},
        {'id': AT_RIM_STRING + PCT_STRING + ASSISTED_STRING, 'text': 'At Rim % Assisted'},
        {'id': SHORT_MID_RANGE_STRING + FREQUENCY_STRING, 'text': 'Short Mid Range Shot Frequency'},
        {'id': SHORT_MID_RANGE_STRING + ACCURACY_STRING, 'text': 'Short Mid Range FG%'},
        {'id': SHORT_MID_RANGE_STRING + PCT_STRING + ASSISTED_STRING, 'text': 'Short Mid Range % Assisted'},
        {'id': LONG_MID_RANGE_STRING + FREQUENCY_STRING, 'text': 'Long Mid Range Shot Frequency'},
        {'id': LONG_MID_RANGE_STRING + ACCURACY_STRING, 'text': 'Long Mid Range FG%'},
        {'id': LONG_MID_RANGE_STRING + PCT_STRING + ASSISTED_STRING, 'text': 'Long Mid % Assisted'},
        {'id': CORNER_3_STRING + FREQUENCY_STRING, 'text': 'Corner 3 Shot Frequency'},
        {'id': CORNER_3_STRING + ACCURACY_STRING, 'text': 'Corner 3 FG%'},
        {'id': CORNER_3_STRING + PCT_STRING + ASSISTED_STRING, 'text': 'Corner 3 % Assisted'},
        {'id': ARC_3_STRING + FREQUENCY_STRING, 'text': 'Above The Break 3 Shot Frequency'},
        {'id': ARC_3_STRING + ACCURACY_STRING, 'text': 'Above The Break 3 FG%'},
        {'id': ARC_3_STRING + PCT_STRING + ASSISTED_STRING, 'text': 'Above The Break 3 % Assisted'},
        {'id': LIVE_BALL_TURNOVER_PERCENTAGE_STRING, 'text': 'Live Ball TO%'},
        {'id': EFG_PCT_STRING, 'text': 'eFG%'},
        {'id': DEFENSIVE_ABBREVIATION_PREFIX + FREE_THROW_STRING + REBOUND_STRING + PCT_STRING, 'text': 'DReb% - Missed FTs'},
        {'id': OFFENSIVE_ABBREVIATION_PREFIX + FREE_THROW_STRING + REBOUND_STRING + PCT_STRING, 'text': 'OReb% - Missed FTs'},
        {'id': DEFENSIVE_ABBREVIATION_PREFIX + TWO_POINT_STRING + REBOUND_STRING + PCT_STRING, 'text': 'DReb% - Missed 2s'},
        {'id': OFFENSIVE_ABBREVIATION_PREFIX + TWO_POINT_STRING + REBOUND_STRING + PCT_STRING, 'text': 'OReb% - Missed 2s'},
        {'id': DEFENSIVE_ABBREVIATION_PREFIX + THREE_POINT_STRING + REBOUND_STRING + PCT_STRING, 'text': 'DReb% - Missed 3s'},
        {'id': OFFENSIVE_ABBREVIATION_PREFIX + THREE_POINT_STRING + REBOUND_STRING + PCT_STRING, 'text': 'OReb% - Missed 3s'},
        {'id': DEFENSIVE_ABBREVIATION_PREFIX + FG_STRING + REBOUND_STRING + PCT_STRING, 'text': 'DReb% - Missed FGs'},
        {'id': OFFENSIVE_ABBREVIATION_PREFIX + FG_STRING + REBOUND_STRING + PCT_STRING, 'text': 'OReb% - Missed FGs'},
        {'id': OFFENSIVE_ABBREVIATION_PREFIX + AT_RIM_STRING + REBOUND_STRING + PCT_STRING, 'text': 'At Rim OReb%'},
        {'id': OFFENSIVE_ABBREVIATION_PREFIX + SHORT_MID_RANGE_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Short Mid-Range OReb%'},
        {'id': OFFENSIVE_ABBREVIATION_PREFIX + LONG_MID_RANGE_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Long Mid-Range OReb%'},
        {'id': OFFENSIVE_ABBREVIATION_PREFIX + ARC_3_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Arc 3 OReb%'},
        {'id': OFFENSIVE_ABBREVIATION_PREFIX + CORNER_3_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Corner 3 OReb%'},
        {'id': DEFENSIVE_ABBREVIATION_PREFIX + AT_RIM_STRING + REBOUND_STRING + PCT_STRING, 'text': 'At Rim DReb%'},
        {'id': DEFENSIVE_ABBREVIATION_PREFIX + SHORT_MID_RANGE_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Short Mid-Range DReb%'},
        {'id': DEFENSIVE_ABBREVIATION_PREFIX + LONG_MID_RANGE_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Long Mid-Range DReb%'},
        {'id': DEFENSIVE_ABBREVIATION_PREFIX + ARC_3_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Arc 3 DReb%'},
        {'id': DEFENSIVE_ABBREVIATION_PREFIX + CORNER_3_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Corner 3 DReb%'},
        {'id': SECOND_CHANCE_STRING + POINTS_ABBREVIATION_STRING + PER_100_POSSESSIONS_STRING + SECOND_CHANCE_STRING, 'text': 'Second Chance Efficiency'},
        {'id': PENALTY_KEY + POINTS_ABBREVIATION_STRING + PER_100_POSSESSIONS_STRING + PENALTY_KEY, 'text': 'Penalty Efficiency'},
        {'id': SECOND_CHANCE_STRING + OFFENSIVE_POSSESSION_STRING + PER_100_POSSESSIONS_STRING, 'text': 'Second Chance Possessions Per 100 Possessions'},
        {'id': FIRST_CHANCE_STRING + POINTS_ABBREVIATION_STRING + PER_100_POSSESSIONS_STRING, 'text': 'First Chance Points Per 100 Possessions'},
        {'id': SECOND_CHANCE_STRING + POINTS_ABBREVIATION_STRING + PER_100_POSSESSIONS_STRING, 'text': 'Second Chance Points Per 100 Possessions'},
        {'id': PENALTY_KEY + OFFENSIVE_POSSESSION_STRING + PER_100_POSSESSIONS_STRING, 'text': 'Penalty Possessions Per 100 Possessions'},
        {'id': AVG_2PT_SHOT_DISTANCE, 'text': 'Avg 2pt Shot Distance'},
        {'id': AVG_3PT_SHOT_DISTANCE, 'text': 'Avg 3pt Shot Distance'}
      ]
    }
  }
}

export const leverage = {
  data () {
    return {
      leverage_dropdown_options: {
        'label': 'Leverage',
        'data': [
          {'id': LOW_LEVERAGE_STRING, 'text': 'Low'},
          {'id': MEDIUM_LEVERAGE_STRING, 'text': 'Medium'},
          {'id': HIGH_LEVERAGE_STRING, 'text': 'High'},
          {'id': VERY_HIGH_LEVERAGE_STRING, 'text': 'Very High'}
        ]
      }
    }
  }
}

export const starterState = {
  data () {
    return {
      starter_state_dropdown_options: {
        'label': 'Starter State',
        'data': [
          {'id': '5v5', 'text': '5v5'},
          {'id': '5v4', 'text': '5v4'},
          {'id': '5v3', 'text': '5v3'},
          {'id': '5v2', 'text': '5v2'},
          {'id': '5v1', 'text': '5v1'},
          {'id': '5v0', 'text': '5v0'},
          {'id': '4v5', 'text': '4v5'},
          {'id': '4v4', 'text': '4v4'},
          {'id': '4v3', 'text': '4v3'},
          {'id': '4v2', 'text': '4v2'},
          {'id': '4v1', 'text': '4v1'},
          {'id': '4v0', 'text': '4v0'},
          {'id': '3v5', 'text': '3v5'},
          {'id': '3v4', 'text': '3v4'},
          {'id': '3v3', 'text': '3v3'},
          {'id': '3v2', 'text': '3v2'},
          {'id': '3v1', 'text': '3v1'},
          {'id': '3v0', 'text': '3v0'},
          {'id': '2v5', 'text': '2v5'},
          {'id': '2v4', 'text': '2v4'},
          {'id': '2v3', 'text': '2v3'},
          {'id': '2v2', 'text': '2v2'},
          {'id': '2v1', 'text': '2v1'},
          {'id': '2v0', 'text': '2v0'},
          {'id': '1v5', 'text': '1v5'},
          {'id': '1v4', 'text': '1v4'},
          {'id': '1v3', 'text': '1v3'},
          {'id': '1v2', 'text': '1v2'},
          {'id': '1v1', 'text': '1v1'},
          {'id': '1v0', 'text': '1v0'},
          {'id': '0v5', 'text': '0v5'},
          {'id': '0v4', 'text': '0v4'},
          {'id': '0v3', 'text': '0v3'},
          {'id': '0v2', 'text': '0v2'},
          {'id': '0v1', 'text': '0v1'},
          {'id': '0v0', 'text': '0v0'}
        ]
      }
    }
  }
}

export const startType = {
  data () {
    return {
      start_type_dropdown_options: {
        'label': 'Possession Start Type',
        'data': [
          {'id': ALL_STRING, 'text': 'All'},
          {'id': OFF_MISSED_FG_STRING, 'text': 'Off Any Missed FG'},
          {'id': OFF_MISSED_2_STRING, 'text': 'Off Any Missed 2'},
          {'id': OFF_MISSED_3_STRING, 'text': 'Off Any Missed 3'},
          {'id': OFF_MADE_FG_STRING, 'text': 'Off Any Made FG'},
          {'id': OFF_MADE_2_STRING, 'text': 'Off Any Made 2'},
          {'id': OFF_MADE_3_STRING, 'text': 'Off Any Made 3'},
          {'id': OFF_AT_RIM_MAKE_STRING, 'text': 'Off At Rim Make'},
          {'id': OFF_AT_RIM_MISS_STRING, 'text': 'Off At Rim Miss'},
          {'id': OFF_AT_RIM_BLOCK_STRING, 'text': 'Off At Rim Block'},
          {'id': OFF_SHORT_MID_RANGE_MAKE_STRING, 'text': 'Off Short Mid-Range Make'},
          {'id': OFF_SHORT_MID_RANGE_MISS_STRING, 'text': 'Off Short Mid-Range Miss'},
          {'id': OFF_LONG_MID_RANGE_MAKE_STRING, 'text': 'Off Long Mid-Range Make'},
          {'id': OFF_LONG_MID_RANGE_MISS_STRING, 'text': 'Off Long Mid-Range Miss'},
          {'id': OFF_ARC_3_MAKE_STRING, 'text': 'Off Arc 3 Make'},
          {'id': OFF_ARC_3_MISS_STRING, 'text': 'Off Arc 3 Miss'},
          {'id': OFF_CORNER_3_MAKE_STRING, 'text': 'Off Corner 3 Make'},
          {'id': OFF_CORNER_3_MISS_STRING, 'text': 'Off Corner 3 Miss'},
          {'id': OFF_MADE_FT_STRING, 'text': 'Off FT Make'},
          {'id': OFF_MISSED_FT_STRING, 'text': 'Off FT Miss'},
          {'id': OFF_LIVE_BALL_TURNOVER_STRING, 'text': 'Off Steal'},
          {'id': OFF_DEADBALL_STRING, 'text': 'Off Dead Ball'},
          {'id': OFF_TIMEOUT_STRING, 'text': 'Off Timeout'}
        ]
      }
    }
  }
}

export const teamPlayerOnOff = {
  data () {
    return {
      team_player_on_off_dropdown: {
        label: 'Stat',
        data: [
          {'id': ASSISTED_STRING + TWOS_STRING + PCT_STRING, 'text': '2pt FGM Assist%'},
          {'id': NON_PUTBACKS_STRING + ASSISTED_STRING + TWOS_STRING + PCT_STRING, 'text': 'Non Putback 2pt FGM Assist%'},
          {'id': ASSISTED_STRING + THREES_STRING + PCT_STRING, 'text': '3pt FGM Assist%'},
          {'id': FG3_PCT_STRING, 'text': '3pt FG%'},
          {'id': NON_HEAVE_FG3_PCT_STRING, 'text': 'Non-Heave 3pt FG%'},
          {'id': FG2_PCT_STRING, 'text': '2pt FG%'},
          {'id': EFG_PCT_STRING, 'text': 'eFG%'},
          {'id': TS_PCT_STRING, 'text': 'TS%'},
          {'id': FG3A_STRING + PCT_STRING, 'text': '3PAr'},
          {'id': FG3A_STRING + PCT_STRING + BLOCKED_STRING, 'text': '% of FG3A Blocked'},
          {'id': FG2A_STRING + PCT_STRING + BLOCKED_STRING, 'text': '% of FG2A Blocked'},
          {'id': LIVE_BALL_TURNOVER_PERCENTAGE_STRING, 'text': 'Live Ball TO%'},
          {'id': DEFENSIVE_ABBREVIATION_PREFIX + FREE_THROW_STRING + REBOUND_STRING + PCT_STRING, 'text': 'DReb% - Missed FTs'},
          {'id': OFFENSIVE_ABBREVIATION_PREFIX + FREE_THROW_STRING + REBOUND_STRING + PCT_STRING, 'text': 'OReb% - Missed FTs'},
          {'id': DEFENSIVE_ABBREVIATION_PREFIX + TWO_POINT_STRING + REBOUND_STRING + PCT_STRING, 'text': 'DReb% - Missed 2s'},
          {'id': OFFENSIVE_ABBREVIATION_PREFIX + TWO_POINT_STRING + REBOUND_STRING + PCT_STRING, 'text': 'OReb% - Missed 2s'},
          {'id': DEFENSIVE_ABBREVIATION_PREFIX + THREE_POINT_STRING + REBOUND_STRING + PCT_STRING, 'text': 'DReb% - Missed 3s'},
          {'id': OFFENSIVE_ABBREVIATION_PREFIX + THREE_POINT_STRING + REBOUND_STRING + PCT_STRING, 'text': 'OReb% - Missed 3s'},
          {'id': DEFENSIVE_ABBREVIATION_PREFIX + FG_STRING + REBOUND_STRING + PCT_STRING, 'text': 'DReb% - Missed FGs'},
          {'id': OFFENSIVE_ABBREVIATION_PREFIX + FG_STRING + REBOUND_STRING + PCT_STRING, 'text': 'OReb% - Missed FGs'},
          {'id': OFFENSIVE_ABBREVIATION_PREFIX + AT_RIM_STRING + REBOUND_STRING + PCT_STRING, 'text': 'At Rim OReb%'},
          {'id': OFFENSIVE_ABBREVIATION_PREFIX + SHORT_MID_RANGE_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Short Mid-Range OReb%'},
          {'id': OFFENSIVE_ABBREVIATION_PREFIX + LONG_MID_RANGE_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Long Mid-Range OReb%'},
          {'id': OFFENSIVE_ABBREVIATION_PREFIX + ARC_3_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Arc 3 OReb%'},
          {'id': OFFENSIVE_ABBREVIATION_PREFIX + CORNER_3_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Corner 3 OReb%'},
          {'id': DEFENSIVE_ABBREVIATION_PREFIX + AT_RIM_STRING + REBOUND_STRING + PCT_STRING, 'text': 'At Rim DReb%'},
          {'id': DEFENSIVE_ABBREVIATION_PREFIX + SHORT_MID_RANGE_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Short Mid-Range DReb%'},
          {'id': DEFENSIVE_ABBREVIATION_PREFIX + LONG_MID_RANGE_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Long Mid-Range DReb%'},
          {'id': DEFENSIVE_ABBREVIATION_PREFIX + ARC_3_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Arc 3 DReb%'},
          {'id': DEFENSIVE_ABBREVIATION_PREFIX + CORNER_3_STRING + REBOUND_STRING + PCT_STRING, 'text': 'Corner 3 DReb%'},
          {'id': BLOCKS_STRING + RECOVERED_STRING + PCT_STRING, 'text': 'Blocks Recovered %'},
          {'id': SECONDS_STRING + PER_POSSESSION_STRING + OFFENSIVE_ABBREVIATION_PREFIX, 'text': 'Seconds Per Possession - Offense'},
          {'id': SECONDS_STRING + PER_POSSESSION_STRING + DEFENSIVE_ABBREVIATION_PREFIX, 'text': 'Seconds Per Possession - Defense'},
          {'id': AT_RIM_STRING + FREQUENCY_STRING, 'text': 'At Rim Shot Frequency'},
          {'id': AT_RIM_STRING + ACCURACY_STRING, 'text': 'At Rim FG%'},
          {'id': AT_RIM_STRING + PCT_STRING + ASSISTED_STRING, 'text': 'At Rim % Assisted'},
          {'id': SHORT_MID_RANGE_STRING + FREQUENCY_STRING, 'text': 'Short Mid Range Shot Frequency'},
          {'id': SHORT_MID_RANGE_STRING + ACCURACY_STRING, 'text': 'Short Mid Range FG%'},
          {'id': SHORT_MID_RANGE_STRING + PCT_STRING + ASSISTED_STRING, 'text': 'Short Mid Range % Assisted'},
          {'id': LONG_MID_RANGE_STRING + FREQUENCY_STRING, 'text': 'Long Mid Range Shot Frequency'},
          {'id': LONG_MID_RANGE_STRING + ACCURACY_STRING, 'text': 'Long Mid Range FG%'},
          {'id': LONG_MID_RANGE_STRING + PCT_STRING + ASSISTED_STRING, 'text': 'Long Mid % Assisted'},
          {'id': CORNER_3_STRING + FREQUENCY_STRING, 'text': 'Corner 3 Shot Frequency'},
          {'id': CORNER_3_STRING + ACCURACY_STRING, 'text': 'Corner 3 FG%'},
          {'id': CORNER_3_STRING + PCT_STRING + ASSISTED_STRING, 'text': 'Corner 3 % Assisted'},
          {'id': ARC_3_STRING + FREQUENCY_STRING, 'text': 'Arc 3 Shot Frequency'},
          {'id': ARC_3_STRING + ACCURACY_STRING, 'text': 'Arc 3 FG%'},
          {'id': ARC_3_STRING + PCT_STRING + ASSISTED_STRING, 'text': 'Arc 3 % Assisted'},
          {'id': AT_RIM_STRING + FG3A_STRING + FREQUENCY_STRING, 'text': 'At Rim or 3pt Shot Frequency'},
          {'id': NON_HEAVE_STRING + ARC_3_STRING + ACCURACY_STRING, 'text': 'Non-Heave Arc 3 FG%'},
          {'id': SHOT_QUALITY_AVG_STRING, 'text': 'Shot Quality'},
          {'id': SHOOTING_FOULS_STRING + DRAWN_STRING + PCT_STRING, 'text': 'Shooting Foul Drawn Rate'},
          {'id': TWO_POINT_STRING + SHOOTING_FOULS_STRING + DRAWN_STRING + PCT_STRING, 'text': '3pt Shooting Foul Drawn Rate'},
          {'id': THREE_POINT_STRING + SHOOTING_FOULS_STRING + DRAWN_STRING + PCT_STRING, 'text': '2pt Shooting Foul Drawn Rate'},
          {'id': SECOND_CHANCE_STRING + POINTS_STRING + PCT_STRING, 'text': 'Second Chance Points%'},
          {'id': PENALTY_KEY + POINTS_STRING + PCT_STRING, 'text': 'Penalty Points%'},
          {'id': PENALTY_KEY + OFFENSIVE_POSSESSION_STRING + PCT_STRING, 'text': 'Penalty Possessions%'},
          {'id': AVG_2PT_SHOT_DISTANCE, 'text': 'Avg 2pt Shot Distance'},
          {'id': AVG_3PT_SHOT_DISTANCE, 'text': 'Avg 3pt Shot Distance'},
          {'id': PENALTY_EFFICIENCY_EXCLUDING_TAKE_FOUL_FTS, 'text': 'Penalty Efficiency Excluding Last Minute Take Foul Possessions'},
          {'id': DEFENSIVE_ABBREVIATION_PREFIX + REBOUND_STRING + PCT_STRING, 'text': 'DReb%'},
          {'id': OFFENSIVE_ABBREVIATION_PREFIX + REBOUND_STRING + PCT_STRING, 'text': 'OReb%'},
          {'id': POINTS_ABBREVIATION_STRING + PER_100_POSSESSIONS_STRING, 'text': 'Pts per 100 Possessions'},
          {'id': ASSIST_POINTS_STRING + PER_100_POSSESSIONS_STRING, 'text': 'Assist Points per 100 Possessions'},
          {'id': FTA_STRING + PER_100_POSSESSIONS_STRING, 'text': 'FTA per 100 Possessions'},
          {'id': TURNOVERS_STRING + PER_100_POSSESSIONS_STRING, 'text': 'TOs per 100 Possessions'},
          {'id': ASSISTS_STRING + PER_100_POSSESSIONS_STRING, 'text': 'Assists per 100 Possessions'},
          {'id': POINTS_ABBREVIATION_STRING + PER_100_POSSESSIONS_STRING + OPPONENT_STRING, 'text': 'Pts per 100 Possessions - Defense'},
          {'id': OPPONENT_STRING + SHOT_QUALITY_AVG_STRING, 'text': 'Shot Quality - Defense'},
          {'id': FG3_PCT_STRING + OPPONENT_STRING, 'text': '3pt FG% - Defense'},
          {'id': FG2_PCT_STRING + OPPONENT_STRING, 'text': '2pt FG% - Defense'},
          {'id': EFG_PCT_STRING + OPPONENT_STRING, 'text': 'eFG% - Defense'},
          {'id': FG3A_STRING + PCT_STRING + OPPONENT_STRING, 'text': '3PAr - Defense'},
          {'id': AT_RIM_STRING + FREQUENCY_STRING + OPPONENT_STRING, 'text': 'At Rim Shot Frequency - Defense'},
          {'id': AT_RIM_STRING + ACCURACY_STRING + OPPONENT_STRING, 'text': 'At Rim FG% - Defense'},
          {'id': SHORT_MID_RANGE_STRING + FREQUENCY_STRING + OPPONENT_STRING, 'text': 'Short Mid Range Shot Frequency - Defense'},
          {'id': SHORT_MID_RANGE_STRING + ACCURACY_STRING + OPPONENT_STRING, 'text': 'Short Mid Range FG% - Defense'},
          {'id': LONG_MID_RANGE_STRING + FREQUENCY_STRING + OPPONENT_STRING, 'text': 'Long Mid Range Shot Frequency - Defense'},
          {'id': LONG_MID_RANGE_STRING + ACCURACY_STRING + OPPONENT_STRING, 'text': 'Long Mid Range FG% - Defense'},
          {'id': CORNER_3_STRING + FREQUENCY_STRING + OPPONENT_STRING, 'text': 'Corner 3 Shot Frequency - Defense'},
          {'id': CORNER_3_STRING + ACCURACY_STRING + OPPONENT_STRING, 'text': 'Corner 3 FG% - Defense'},
          {'id': ARC_3_STRING + FREQUENCY_STRING + OPPONENT_STRING, 'text': 'Arc 3 Shot Frequency - Defense'},
          {'id': ARC_3_STRING + ACCURACY_STRING + OPPONENT_STRING, 'text': 'Arc 3 FG% - Defense'},
          {'id': PACE_STRING, 'text': 'Pace'},
          {'id': SECOND_CHANCE_STRING + POINTS_ABBREVIATION_STRING + PER_100_POSSESSIONS_STRING + SECOND_CHANCE_STRING, 'text': 'Second Chance Efficiency'},
          {'id': PENALTY_KEY + POINTS_ABBREVIATION_STRING + PER_100_POSSESSIONS_STRING + PENALTY_KEY, 'text': 'Penalty Efficiency'},
          {'id': SECOND_CHANCE_STRING + OFFENSIVE_POSSESSION_STRING + PER_100_POSSESSIONS_STRING, 'text': 'Second Chance Possessions Per 100 Possessions'},
          {'id': FIRST_CHANCE_STRING + POINTS_ABBREVIATION_STRING + PER_100_POSSESSIONS_STRING, 'text': 'First Chance Points Per 100 Possessions'},
          {'id': SECOND_CHANCE_STRING + POINTS_ABBREVIATION_STRING + PER_100_POSSESSIONS_STRING, 'text': 'Second Chance Points Per 100 Possessions'}
        ]
      }
    }
  }
}

// data_options = [{'id': key, 'text': stat_sums.TOP_RESULTS_STATS[key]['label'], 'pct': False} for key in stat_sums.TOP_RESULTS_STATS.keys()]
// data_options += [{'id': key, 'text': percentage_stats.TOP_RESULTS_STATS[key]['text_display'], 'pct': True} for key in percentage_stats.TOP_RESULTS_STATS.keys()]
export const topResults = {
  data () {
    return {
      top_results_stat_dropdown: {
        'data': [
          {
            'id': 'AtRimFGA',
            'pct': false,
            'text': 'Rim FGA'
          },
          {
            'id': 'AtRimFGM',
            'pct': false,
            'text': 'Rim FGM'
          },
          {
            'id': 'ShortMidRangeFGA',
            'pct': false,
            'text': 'Short Mid-Range FGA'
          },
          {
            'id': 'ShortMidRangeFGM',
            'pct': false,
            'text': 'Short Mid-Range FGM'
          },
          {
            'id': 'LongMidRangeFGA',
            'pct': false,
            'text': 'Long Mid-Range FGA'
          },
          {
            'id': 'LongMidRangeFGM',
            'pct': false,
            'text': 'Long Mid-Range FGM'
          },
          {
            'id': 'Corner3FGA',
            'pct': false,
            'text': 'Corner 3 FGA'
          },
          {
            'id': 'Corner3FGM',
            'pct': false,
            'text': 'Corner 3 FGM'
          },
          {
            'id': 'Arc3FGA',
            'pct': false,
            'text': 'Above The Break 3 FGA'
          },
          {
            'id': 'Arc3FGM',
            'pct': false,
            'text': 'Above The Break 3 FGM'
          },
          {
            'id': 'UnassistedAtRim',
            'pct': false,
            'text': 'Unassisted Rim FGM'
          },
          {
            'id': 'AssistedAtRim',
            'pct': false,
            'text': 'Assisted Rim FGM'
          },
          {
            'id': 'UnassistedShortMidRange',
            'pct': false,
            'text': 'Unassisted Short Mid-Range FGM'
          },
          {
            'id': 'AssistedShortMidRange',
            'pct': false,
            'text': 'Assisted Short Mid-Range FGM'
          },
          {
            'id': 'UnassistedLongMidRange',
            'pct': false,
            'text': 'Unassisted Long Mid-Range FGM'
          },
          {
            'id': 'AssistedLongMidRange',
            'pct': false,
            'text': 'Assisted Long Mid-Range FGM'
          },
          {
            'id': 'UnassistedCorner3',
            'pct': false,
            'text': 'Unassisted Corner 3 FGM'
          },
          {
            'id': 'AssistedCorner3',
            'pct': false,
            'text': 'Assisted Corner 3 FGM'
          },
          {
            'id': 'UnassistedArc3',
            'pct': false,
            'text': 'Unassisted Above The Break 3 FGM'
          },
          {
            'id': 'AssistedArc3',
            'pct': false,
            'text': 'Assisted Above The Break 3 FGM'
          },
          {
            'id': 'Fg3aBlocked',
            'pct': false,
            'text': 'Blocked FG3A'
          },
          {
            'id': 'Fg2aBlocked',
            'pct': false,
            'text': 'Blocked FG2A'
          },
          {
            'id': 'LiveBallTurnovers',
            'pct': false,
            'text': 'Liveball Turnovers'
          },
          {
            'id': 'DeadBallTurnovers',
            'pct': false,
            'text': 'Deadball Turnovers'
          },
          {
            'id': 'Turnovers',
            'pct': false,
            'text': 'Turnovers'
          },
          {
            'id': 'AssistedFG2M',
            'pct': false,
            'text': 'Assisted FG2M'
          },
          {
            'id': 'UnassistedFG2M',
            'pct': false,
            'text': 'Unassisted FG2M'
          },
          {
            'id': 'AssistedFG3M',
            'pct': false,
            'text': 'Assisted FG3M'
          },
          {
            'id': 'UnassistedFG3M',
            'pct': false,
            'text': 'Unassisted FG3M'
          },
          {
            'id': 'Putbacks',
            'pct': false,
            'text': 'Putbacks'
          },
          {
            'id': 'FG2A',
            'pct': false,
            'text': 'FG2A'
          },
          {
            'id': 'FG2M',
            'pct': false,
            'text': 'FG2M'
          },
          {
            'id': 'FG3A',
            'pct': false,
            'text': 'FG3A'
          },
          {
            'id': 'FG3M',
            'pct': false,
            'text': 'FG3M'
          },
          {
            'id': 'AtRimAssists',
            'pct': false,
            'text': 'Rim Assists'
          },
          {
            'id': 'Corner3Assists',
            'pct': false,
            'text': 'Corner 3 Assists'
          },
          {
            'id': 'Arc3Assists',
            'pct': false,
            'text': 'Above The Break 3 Assists'
          },
          {
            'id': 'TwoPtAssists',
            'pct': false,
            'text': '2pt Assists'
          },
          {
            'id': 'ThreePtAssists',
            'pct': false,
            'text': '3pt Assists'
          },
          {
            'id': 'AssistPoints',
            'pct': false,
            'text': 'Assist Points'
          },
          {
            'id': 'OffThreePtRebounds',
            'pct': false,
            'text': '3pt ORebs'
          },
          {
            'id': 'OffTwoPtRebounds',
            'pct': false,
            'text': '2pt ORebs'
          },
          {
            'id': 'FTOffRebounds',
            'pct': false,
            'text': 'FT ORebs'
          },
          {
            'id': 'DefThreePtRebounds',
            'pct': false,
            'text': '3pt DRebs'
          },
          {
            'id': 'DefTwoPtRebounds',
            'pct': false,
            'text': '2pt DRebs'
          },
          {
            'id': 'FTDefRebounds',
            'pct': false,
            'text': 'FT DRebs'
          },
          {
            'id': 'ShootingFouls',
            'pct': false,
            'text': 'Shooting Fouls Committed'
          },
          {
            'id': 'FoulsDrawn',
            'pct': false,
            'text': 'Fouls Drawn'
          },
          {
            'id': 'TwoPtShootingFoulsDrawn',
            'pct': false,
            'text': '2pt Shooting Fouls Drawn'
          },
          {
            'id': 'ThreePtShootingFoulsDrawn',
            'pct': false,
            'text': '3pt Shooting Fouls Drawn'
          },
          {
            'id': 'NonShootingFoulsDrawn',
            'pct': false,
            'text': 'Non-shooting Fouls Drawn That Earned FTs'
          },
          {
            'id': 'Offensive Fouls',
            'pct': false,
            'text': 'Offensive Fouls Committed'
          },
          {
            'id': 'Offensive FoulsDrawn',
            'pct': false,
            'text': 'Offensive Fouls Drawn'
          },
          {
            'id': 'Charge Fouls',
            'pct': false,
            'text': 'Charges Committed'
          },
          {
            'id': 'Charge FoulsDrawn',
            'pct': false,
            'text': 'Charges Drawn'
          },
          {
            'id': 'Blocked2s',
            'pct': false,
            'text': 'Blocked 2s'
          },
          {
            'id': 'Blocked3s',
            'pct': false,
            'text': 'Blocked 3s'
          },
          {
            'id': 'TotalPoss',
            'pct': false,
            'text': 'Total Possessions'
          },
          {
            'id': 'Minutes',
            'pct': false,
            'text': 'Minutes'
          },
          {
            'id': 'PtsPer100Poss',
            'pct': true,
            'text': 'Points Per 100 Possessions'
          },
          {
            'id': 'AtRimFrequency',
            'pct': true,
            'text': 'At Rim Shot Frequency'
          },
          {
            'id': 'AtRimAccuracy',
            'pct': true,
            'text': 'At Rim FG%'
          },
          {
            'id': 'AtRimPctAssisted',
            'pct': true,
            'text': 'At Rim % Assisted'
          },
          {
            'id': 'ShortMidRangeFrequency',
            'pct': true,
            'text': 'Short Mid Range Shot Frequency'
          },
          {
            'id': 'ShortMidRangeAccuracy',
            'pct': true,
            'text': 'Short Mid Range FG%'
          },
          {
            'id': 'ShortMidRangePctAssisted',
            'pct': true,
            'text': 'Short Mid Range % Assisted'
          },
          {
            'id': 'LongMidRangeFrequency',
            'pct': true,
            'text': 'Long Mid Range Shot Frequency'
          },
          {
            'id': 'LongMidRangeAccuracy',
            'pct': true,
            'text': 'Long Mid Range FG%'
          },
          {
            'id': 'LongMidRangePctAssisted',
            'pct': true,
            'text': 'Long Mid % Assisted'
          },
          {
            'id': 'Corner3Frequency',
            'pct': true,
            'text': 'Corner 3 Shot Frequency'
          },
          {
            'id': 'Corner3Accuracy',
            'pct': true,
            'text': 'Corner 3 FG%'
          },
          {
            'id': 'Corner3PctAssisted',
            'pct': true,
            'text': 'Corner 3 % Assisted'
          },
          {
            'id': 'Arc3Frequency',
            'pct': true,
            'text': 'Above The Break 3 Shot Frequency'
          },
          {
            'id': 'Arc3Accuracy',
            'pct': true,
            'text': 'Above The Break 3 FG%'
          },
          {
            'id': 'Arc3PctAssisted',
            'pct': true,
            'text': 'Above The Break 3 % Assisted'
          },
          {
            'id': 'EfgPct',
            'pct': true,
            'text': 'eFG%'
          },
          {
            'id': 'AssistPointsPer100Poss',
            'pct': true,
            'text': 'Assist Points per 100 Possessions'
          },
          {
            'id': 'DefFTReboundPct',
            'pct': true,
            'text': 'DReb% - Missed FTs'
          },
          {
            'id': 'OffFTReboundPct',
            'pct': true,
            'text': 'OReb% - Missed FTs'
          },
          {
            'id': 'DefTwoPtReboundPct',
            'pct': true,
            'text': 'DReb% - Missed 2s'
          },
          {
            'id': 'OffTwoPtReboundPct',
            'pct': true,
            'text': 'OReb% - Missed 2s'
          },
          {
            'id': 'DefThreePtReboundPct',
            'pct': true,
            'text': 'DReb% - Missed 3s'
          },
          {
            'id': 'OffThreePtReboundPct',
            'pct': true,
            'text': 'OReb% - Missed 3s'
          },
          {
            'id': 'DefFGReboundPct',
            'pct': true,
            'text': 'DReb% - Missed FGs'
          },
          {
            'id': 'OffFGReboundPct',
            'pct': true,
            'text': 'OReb% - Missed FGs'
          }
        ],
        'label': 'Stat'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/dropdowns.js